import React from 'react';

import { PrintDeliveryRequestLog as PrintDeliveryRequestLogImpl } from '@components/utilities/DeliveryRequest/PrintDeliveryRequestLog';

export const PrintDeliveryRequestLog = () => {
  return <PrintDeliveryRequestLogImpl type="external" />;
};
